<template>
  <div class="individuals-dropdown" :id="id">
    <div class="individuals-dropdown-toggle" :style="{ backgroundColor: color }" @click="toggle()">
      <p class="text-light">{{title}}</p>
      <span class="kcm text-light" :class="{ 'rotated' : opened}">C</span>
    </div>
    <div v-show="opened" class="individuals-dropdown-content">
      <!-- IF WE HAVE A TABLE FOR THE CURRENT DROPDOWN -->
      <table v-if="content.table">
        <tr v-for="(row, i) in content.table" :key="`${id}-table-row-${i}`">
          <td
            v-for="(cell, j) in row"
            :key="`${id}-table-row-${i}-cell-${j}`"
            :colspan="cell.colspan"
          >
            <!-- IF THE TYPE OF DATA IS AN OBJECT -->
            <!-- WE CAN HAVE A COLSPAN ^^^ -->
            <!-- IF WE HAVE THE 'EL' KEY THE TEXT IS WRAPPED INSIDE A 'BOX' WITH BACKGROUND -->
            <!-- AND IF WE HAVE THE 'TEXT' IT IS JUST A NORMAL TEXT -->
            <span v-if="typeof cell == 'object'">
              <span
                v-if="cell.el"
                class="text-light mini-element"
                :style="{ backgroundColor: color }"
              >{{cell.el}}</span>
              <span v-if="cell.text" v-html="cell.html"></span>
            </span>
            <span v-else v-html="cell"></span>
          </td>
        </tr>
      </table>
      <!-- COLUMNS -->
      <div v-if="content.columns" class="individuals-dropdown-columns">
        <!-- IF THERE ARE MAIN TITLES -->
        <template v-if="content.columns.titles">
          <p
            v-for="(title, ind) in content.columns.titles"
            :key="`${id}-columns-titles-${ind}`"
            class="individuals-dropdown-columns-title"
            v-html="title"
          ></p>
        </template>
        <div class="individuals-dropdown-columns-grid">
          <!-- 'LOOP' FOR EVERY COLUMN - LEFT AND RIGHT -->
          <div
            v-for="p in ['left', 'right']"
            :key="`${p}-column`"
            class="individuals-dropdown-columns-item"
          >
            <!-- IN EVERY COLUMN(ARRAY) THERE ARE SMALL OBJECTS WITH DIFFERENT KEY/VALUE PAIRS AND WE LOOP THROUGH THEM -->
            <div v-for="(item, i) in content.columns[p]" :key="`column-${p}-item-${i}`">
              <!-- IF THERE IS IMG KEY -->
              <img v-if="item.img" :src="item.img" alt="Dropdown image">
              <!-- IF THERE IS TITLE KEY -->
              <p v-if="item.title" class="strong item-text" :style="{ color: color }" v-html="item.title"></p>
              <!-- IF THERE IS TEXT ARRAY -->
              <template v-if="item.texts">
                <p
                  v-for="(t, j) in item.texts"
                  class="item-text"
                  :key="`column-${p}-item-${i}-text-${j}`"
                  v-html="t"
                ></p>
              </template>
              <!-- IF THERE IS A SPEC -->
              <div class="spec" v-if="item.spec">
                <!-- SPEC TITLE -->
                <p class="medium spec-title">{{ item.spec.title }}</p>
                <div class="spec-columns">
                  <div class="spec-columns-left">
                    <div class="spec-columns-content">
                      <span class="medium">{{ item.spec.mass }}</span>
                      <span class="kcm" :style="{ color: color }">U</span>
                    </div>
                    <p class="spec-columns-bottom">{{item.spec.left}}</p>
                  </div>
                  <div class="spec-columns-right">
                    <div class="spec-columns-content">
                      <div class="spec-columns-row" v-if="item.spec.l0">
                        <span :style="{ color: color }">L</span>
                        <span class="medium" v-html="item.spec.l0"></span>
                      </div>
                      <div class="spec-columns-row" v-if="item.spec.w0">
                        <span :style="{ color: color }">W</span>
                        <span class="medium" v-html="item.spec.w0"></span>
                      </div>
                      <div class="spec-columns-row" v-if="item.spec.h0">
                        <span :style="{ color: color }">H</span>
                        <span class="medium" v-html="item.spec.h0"></span>
                      </div>
                      <div class="spec-columns-row">
                        <span :style="{ color: color }">L</span>
                        <span class="medium" v-html="item.spec.l"></span>
                      </div>
                      <div class="spec-columns-row">
                        <span :style="{ color: color }">W</span>
                        <span class="medium" v-html="item.spec.w"></span>
                      </div>
                      <div class="spec-columns-row">
                        <span :style="{ color: color }">H</span>
                        <span class="medium" v-html="item.spec.h"></span>
                      </div>
                    </div>
                    <p class="spec-columns-bottom">{{item.spec.right}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "color", "title", "open", "content"],
  data() {
    return {
      opened: false
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    }
  },
  mounted() {
    if (this.open) {
      this.opened = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.individuals-dropdown {
  margin-bottom: 10px;
}
.individuals-dropdown-toggle {
  @extend %flex-center;
  cursor: pointer;
  height: 44px;
  justify-content: space-between;
  padding: 0 15px;
  @include transition(all 0.3s);
  p {
    font-weight: 500;
  }
  .kcm {
    @include transition(all 0.3s);
  }
  .rotated {
    @include transform(scale(-1));
  }
}
.individuals-dropdown-toggle:hover {
  opacity: 0.9;
}
.individuals-dropdown-content {
  table {
    width: 100%;
    tr:nth-of-type(2n) {
      background-color: #e5e7e5;
    }
    td {
      height: 30px;
      padding: 5px;
      text-align: center;
      vertical-align: middle;
      width: 1%;
      .mini-element {
        @extend %flex-center;
        display: inline-flex;
        height: 30px;
        margin: 0 5px;
        width: 30px;
      }
      sub {
        transform: scale(0.6);
      }
    }
  }
  .individuals-dropdown-columns {
    @extend %flex-center;
    flex-direction: column;
    margin-top: 30px;
    .individuals-dropdown-columns-title {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;
      text-align: center;
      width: 100%;
    }
    .individuals-dropdown-columns-title:last-of-type {
      margin-bottom: 30px;
    }
    .individuals-dropdown-columns-grid {
      display: flex;
      min-height: 1px;
      width: 100%;
      .individuals-dropdown-columns-item {
        width: calc(50% - 10px);
        img {
          display: inline-block;
          height: auto;
          min-height: 1px;
          margin-bottom: 10px;
          width: 100%;
        }
        .item-text {
          margin-bottom: 5px;
        }
      }
      .individuals-dropdown-columns-item:first-of-type {
        margin-right: 20px;
      }
    }
  }
  .spec {
    background-color: #e5e7e5;
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    .spec-title {
      text-align: center;
      border-bottom: 1px solid #fff;
      margin: 0;
      padding: 6px;
    }
    .spec-columns {
      display: flex;
      .spec-columns-left,
      .spec-columns-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 7px 7px 0;
        width: 50%;
        .spec-columns-content {
          align-items: center;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          padding: 15px;
          .spec-columns-row {
            display: flex;
            justify-content: space-between;
            padding: 5px 0;
            width: 100%;
            // span:first-child {
              // opacity: 0.6;
            // }
          }
          span {
            font-size: 16px;
            text-align: center;
          }
          .kcm {
            font-size: 50px;
            margin-top: 10px;
            // opacity: 0.6;
          }
        }
        .spec-columns-bottom {
          padding: 6px;
          text-align: center;
        }
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .individuals-dropdown-toggle {
    p {
      font-size: 13px;
    }
  }
  .individuals-dropdown-toggle:hover {
    opacity: 0.9;
  }
  .individuals-dropdown-content {
    table {
      td {
        .mini-element {
          font-size: 12px;
        }
      }
    }
    .individuals-dropdown-columns {
      .individuals-dropdown-columns-title {
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
    .spec {
      .spec-columns {
        .spec-columns-left,
        .spec-columns-right {
          .spec-columns-content {
            span {
              font-size: 13px;
            }
            .kcm {
              font-size: 50px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .individuals-dropdown-toggle {
    p {
      font-size: 12px;
    }
  }
  .individuals-dropdown-toggle:hover {
    opacity: 0.9;
  }
  .individuals-dropdown-content {
    table {
      td {
        font-size: 11px;
        .mini-element {
          height: 25px;
          font-size: 11px;
          width: 25px;
        }
      }
    }
    .individuals-dropdown-columns {
      .individuals-dropdown-columns-title {
        font-size: 12px;
        margin-bottom: 0;
      }
    }
    .spec {
      .spec-columns {
        .spec-columns-left,
        .spec-columns-right {
          .spec-columns-content {
            span {
              font-size: 12px;
            }
            .kcm {
              font-size: 40px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .individuals-dropdown-content {
    .individuals-dropdown-columns {
      .individuals-dropdown-columns-grid {
        flex-direction: column;
        .individuals-dropdown-columns-item {
          width: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .individuals-dropdown-content {
    .individuals-dropdown-columns {
      .individuals-dropdown-columns-grid {
        flex-direction: column;
        .individuals-dropdown-columns-item {
          width: 100%;
          .spec {
            .spec-columns {
              flex-direction: column;
              .spec-columns-left,
              .spec-columns-right {
                width: 100%;
              }
              .spec-columns-right {
                padding-top: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>

